import { withAITracking } from '@microsoft/applicationinsights-react-js';

import { getReactPlugin } from './appInsightsIntegration';

/**
 * HOC for enhanced component tracking with App Insights React plugin
 */
export function withAppInsightsTracking<P extends object>(Component: React.ComponentType<P>, componentName?: string) {
  const reactPlugin = getReactPlugin();

  if (!reactPlugin) {
    console.warn('React plugin not initialized, returning unwrapped component');

    return Component;
  }

  return withAITracking(reactPlugin, Component, componentName);
}
